import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '../common/font/font.css'
// 挂载一个自定义属性$http
Vue.prototype.$http = axios
// 全局配置axios请求根路径(axios.默认配置.请求根路径)
axios.defaults.baseURL = 'https://test.shine-hydrogen.com'
import * as echarts from 'echarts' //引入echart
// import echarts from 'echarts'
Vue.prototype.$echarts=echarts;  //echarts 需要挂在到VUE原型上
Vue.prototype.$url='https://cdn.shine-hydrogen.com'
import "./utils/china.js";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);                                                       
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.prototype.imgUrl = e => {
  if (!e) {
    return ''
  } else if (e.substring(0, 4) != 'http') {
    return 'https://test.shine-hydrogen.com' + e
  } else {
    return e
  }
}
Vue.prototype.filtersText = val => {
  if (val != null && val != "") {
    const rel = new RegExp("<.+?>","g");
    return val.replace(rel,'').trim();
  }
  return "";
}



// WEBPACK FOOTER //
// ./src/main.js